import {Component, Inject} from '@angular/core';
import {DIALOG_DATA, DialogRef} from "@angular/cdk/dialog";

export enum PromptDialogResult {
  OK,
  CANCEL,
}

@Component({
  selector: 'prompt-dialog',
  templateUrl: './prompt-dialog.component.html',
  styleUrls: ['./prompt-dialog.component.scss'],
})
export class PromptDialogComponent {
  public readonly title: string;
  public readonly body: string;

  public confirmAction = 'Ja, löschen';
  public cancelAction = 'Nein, abbrechen';

  public closeActionEnabled = false;
  public hideActions = false;
  public hideHeader = false;

  constructor(
    @Inject(DIALOG_DATA) // injection token
    public data: {
      title: string;
      body: string;
      confirmAction?: string;
      cancelAction?: string;
      closeActionEnabled?: boolean;
      hideActions?: boolean;
      hideHeader?: boolean;
    },
    private dialogRef: DialogRef<PromptDialogResult>
  ) {
    this.title = data.title;
    this.body = data.body;
    this.confirmAction = data.confirmAction || this.confirmAction;
    this.cancelAction = data.cancelAction || this.cancelAction;
    this.closeActionEnabled = data.closeActionEnabled === true;
    this.hideActions = data.hideActions;
    this.hideHeader = data.hideHeader;
  }

  public close(): void {
    this.dialogRef.close(PromptDialogResult.CANCEL);
  }

  public confirm(): void {
    this.dialogRef.close(PromptDialogResult.OK);
  }
}
